import React, { useEffect } from "react";

type ProviderProps = {
  children: React.ReactNode;
};

const initialEnvironment = {
  isProd: false,
};

const EnvironmentContext = React.createContext<{ isProd: boolean }>(
  initialEnvironment
);

export const EnvironmentProvider: React.FunctionComponent<ProviderProps> = ({
  children,
}) => {
  const [isProd, setIsProd] = React.useState<boolean>(false);
  useEffect(() => {
    setIsProd(!!+(process.env.GATSBY_IS_PROD || false));
  }, []);

  return (
    <EnvironmentContext.Provider value={{ isProd }}>
      {children}
    </EnvironmentContext.Provider>
  );
};

export const useEnvironmentContext = () => {
  const context = React.useContext(EnvironmentContext);
  if (!context)
    throw new Error(
      "useEnvironmentContext must be used within an EnvironmentProvider"
    );
  return context;
};
